import { useRef } from 'react';
import { useExperienceTracker } from '../context';
var ExperienceMark = function ExperienceMark(_ref) {
  var mark = _ref.mark,
    phase = _ref.phase,
    timestamp = _ref.timestamp;
  var experienceTracker = useExperienceTracker();
  var wasCalledRef = useRef(false);
  if (!wasCalledRef.current) {
    wasCalledRef.current = true;
    if (phase === 'start') {
      experienceTracker.markStart(mark, timestamp);
    } else {
      experienceTracker.markEnd(mark, timestamp);
    }
  }
  return null;
};
export { ExperienceMark };